import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SESSION_PORT } from '../ports/auth-session.port';

export const noAuthGuard: CanActivateFn = () => {
  const session = inject(AUTH_SESSION_PORT);
  const router = inject(Router);

  if (session.isAuthenticated()) {
    return router.createUrlTree(['/home']);
  }

  return true;
};
